<!--
 * $Description: 分页组件
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年06月04日 17:49:30 +0800
 * @最后修改时间: 2022-06-08 13:35:20
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_Pagenations.vue
-->
<template>
  <div>
    <v-divider />
    <v-sheet
      :class="dense ? 'pt-0' : ''"
      class="
        pa-2
        pb-0
        max-width
        d-flex
        flex-nowrap
        align-center
        justify-space-between
      "
    >
      <!-- <TableManageTools v-if="showSelect" /> -->
      <span class="text-caption text--secondary">
        {{ other }}
        {{ $t("label_essweb_list_components_pagenations_columnLabel") }}({{
          $t("label_essweb_list_components_pagenations_totalLabel")
        }}
        {{ length }}
        {{ $t("label_essweb_list_components_pagenations_columnLabel") }})
      </span>
      <v-spacer></v-spacer>
      <v-pagination
        v-model="page"
        @input="
          () => {
            if (isLoading || localLoading) return;
          }
        "
        :disabled="isLoading || localLoading"
        color="grey lighten-2 "
        class="text--primary d-inline-block text-truncate text-center"
        prev-icon="navigate_before"
        next-icon="navigate_next"
        :length="
          Math.ceil(
            length /
              (options.pagination.itemsPerPage == -1
                ? length
                : options.pagination.itemsPerPage)
          )
        "
        :total-visible="7"
      />
      <v-spacer v-if="showItemPages"></v-spacer>
      <span class="text-caption text--secondary pr-1" v-if="showItemPages">{{
        options.itemsPerPageText
      }}</span>
      <v-menu offset-y small v-if="showItemPages">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            width="60"
            height="28"
            outlined
            depressed
            style="
              border-color: rgba(0, 0, 0, 0.1) !important;
              border-radius: 6px;
              min-width: 60px;
            "
            x-small
            class="
              mrc-border-solid
              text-capitalize
              pa-0
              white
              text-body-2
              d-flex
              justify-space-around
            "
            text
          >
            {{
              options.pagination.itemsPerPage == -1
                ? $t(
                    "label_essweb_list_components_pagenations_selectNumber_allLabel"
                  )
                : options.pagination.itemsPerPage
            }}
            <i class="material-icons-round">arrow_drop_down</i>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-for="(item, index) in options.itemsPerPageOptions"
            :key="index"
            @click="perpage = item"
          >
            <v-list-item-title>{{
              item == -1
                ? $t(
                    "label_essweb_list_components_pagenations_selectNumber_allLabel"
                  )
                : item
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-sheet>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Pagenations",
  computed: {
    ...mapGetters(["companyLang", "isLoading", "SelectionRefresh"]),
    length() {
      if (!this.items) return 0;
      return this.isNumber(this.items) ? this.items : this.items.length;
    },
    other() {
      if (this.isNumber(this.items)) {
        let start =
          this.page == 1
            ? 1
            : Number(this.perpage) * (Number(this.page) - 1) + 1;
        let end =
          this.page == 1
            ? Number(this.perpage) * Number(this.page)
            : Number(this.perpage) * Number(this.page);
        if (Number(end) > Number(this.items)) {
          end = Number(this.items);
        }
        return start + " - " + end;
      } else {
        return (
          (this.options.pagination.pageStart == 0
            ? this.options.pagination.pageStart + 1
            : this.options.pagination.pageStart + 1) +
          " - " +
          this.options.pagination.pageStop
        );
      }
    },
    // perpage() {
    //   return this.options.pagination.itemsPerPage;
    // },
  },
  props: {
    showSelect: { default: false, type: Boolean },
    dense: { default: false, type: Boolean },
    showItemPages: { default: true, type: Boolean },
    options: { type: Object },
    pagetype: { default: "", type: [String, Number] },
    items: { default: [], type: [Array, Number] },
    filterpage: { default: [], type: [String, Number] },
    localLoading: { default: false, type: Boolean }, //非服务端分页使用
    filterItemsPerPage: {
      default: () => {
        return [];
      },
      type: [String, Number, Object, Array],
    },
  },
  watch: {
    page(val, old) {
      if (this.isLoading || this.localLoading) return;
      this.$emit("change", val, this.perpage);
    },
    perpage(val) {
      this.options.pagination.itemsPerPage = val;
      if (this.page == 1) {
        this.$emit("change", 1, val);
      } else {
        this.page = 1;
      }
    },
    filterpage(val) {
      const that = this;
      this.pageChange = false;
      this.page = val;
      this.$Sleep(1000).then(() => {
        that.pageChange = true; // 解决page的变化引起的多一次请求
      });
    },
    filterItemsPerPage(val) {
      this.options.pagination.itemsPerPage = val;
    },
  },
  data() {
    return { page: 1, pageChange: false, perpage: 20 };
  },
  mounted() {
    if (this.options)
      this.options.pagination.itemsPerPage = this.$tableSetting.perPageSize; //强制初始化
    if (!(this.pagetype == "leavebalance" || this.pagetype == "claimbalance")) {
      //休假结余特殊//报销结余特殊
      this.options.pagination.itemsPerPage = this.options
        ? this.options.pagination.itemsPerPage
        : this.$tableSetting.perPageSize;
      // this.setPerPage(
      //   this.options
      //     ? this.options.pagination.itemsPerPage
      //     : this.$tableSetting.perPageSize,
      //   true
      // );
    } else {
      this.pageChange = true; //激活頁碼
    }
  },
  methods: {
    isNumber: function (val) {
      var regPos = /^\d+(\.\d+)?$/; //非负浮点数
      var regNeg =
        /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
      if (regPos.test(val) || regNeg.test(val)) {
        return true;
      } else {
        return false;
      }
    },
    setPerPage: function (perpage, triger) {
      const that = this;

      // this.pageChange = triger ? triger : false;
      // if (Number(this.options.pagination.itemsPerPage) !== Number(perpage)) {
      //   this.page = 1;
      //   this.options.pagination.itemsPerPage = perpage;
      //   this.$emit("change", 1, perpage);
      // }
      // this.$Sleep(500).then(() => {
      //   that.pageChange = true; // 解决page的变化引起的多一次请求
      // });
    },
  },
};
</script>
